module.exports = __webpack_public_path__ + "img/help-icon.dab2492b.svg";